module.exports = __webpack_public_path__ + "sg/img/bottom.e235939.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bottom.png
// module id = M2uH
// module chunks = 0